export default "__VITE_ASSET__DB_FPw2E__"